import { TemplateHandler } from '@helpers/formatter';

export function useTemplate() {
  return new TemplateHandler();
}
